import ExtensionOption from "@/types/ExtensionOption.interface"

interface State {
    customFieldsExtensionOptions: ExtensionOption[]
    customFieldsSelectedExtensionOption: ExtensionOption
}

const defaults = () => {
    return {
        customFieldsExtensionOptions: [],
        customFieldsSelectedExtensionOption: null
    }
}

export default {
    state: defaults(),
    mutations: {
        customFieldsExtensionOptionsPush (state: State, extensions: ExtensionOption[]): void {
            state.customFieldsExtensionOptions = window.removeDuplicatesById(state.customFieldsExtensionOptions, extensions)

            //  Get the currently selected extension
            const selected = state.customFieldsSelectedExtensionOption

            //  If the extension does NOT exist, do nothing
            if (!selected) return

            //  Else, find if they are in the updated extensions list
            const updatedExtensionOption = extensions.find((x: ExtensionOption) => x.id == selected.id)

            //  If not found, then do nothing
            if (!updatedExtensionOption) return

            //  Else, updated the selected extension
            state.customFieldsSelectedExtensionOption = updatedExtensionOption
        },
        customFieldsExtensionOptionsRemove (state: State, ids: number[]): void {
            //  Get our current lists of extensions
            const extensions = state.customFieldsExtensionOptions

            //  If no extensions, do nothing
            if (!extensions) return

            //  Else, filter out our removed ids
            const filtered = extensions.filter((x: ExtensionOption) => !ids.includes(x.id))

            //  Replace with the filtered list
            state.customFieldsExtensionOptions = filtered

            //  Get the currently selected extension
            const selected = state.customFieldsSelectedExtensionOption

            //  If the extension does NOT exist, then do nothing
            if (!selected) return

            //  Else, check if they are in our array
            const deleted = ids.find((x: number) => x == selected.id)

            //  If not found, do nothing
            if (!deleted) return

            //  Else, set the selected extension to null since it is now deleted
            state.customFieldsSelectedExtensionOption = null
        },
        customFieldsExtensionOptionsSet (state: State, extensions: ExtensionOption[]): void {
            state.customFieldsExtensionOptions = extensions
        },
        customFieldsSelectedExtensionOptionSet (state: State, extension: ExtensionOption): void {
            state.customFieldsSelectedExtensionOption = extension
        },
        customFieldsReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        customFieldsSelectedExtensionOptionGet ({ commit, getters }, extensionId: number): Promise<ExtensionOption> {
            //  Grab the global extensions list
            const extensions = getters.extensionOptions

            //  Check if this extension already exists within
            const existingExtensionOption = extensions.find((x: ExtensionOption) => x.id == extensionId)

            //  If there IS an existing extension, commit that and proceed
            if (existingExtensionOption) return commit('customFieldsSelectedExtensionOptionSet', existingExtensionOption)

            //  Else, assemble the API endpoint
            const url = `${getters.api}/ext-options/${extensionId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set the selected extension
                commit('customFieldsSelectedExtensionOptionSet', response.data)

                //  Push into our global dataset
                commit('extensionOptionsPush', [response.data])

                //  Return our extension
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        customFieldsExtensionOptions (state: State): ExtensionOption[] {
            return state.customFieldsExtensionOptions
        },
        customFieldsSelectedExtensionOption (state: State): ExtensionOption {
            return state.customFieldsSelectedExtensionOption
        }
    }
}